module.exports = __webpack_public_path__ + "media/images/metronic/social/behance-14b8a56f1f2c99517ba2de97f6055184.png";